import React from "react"
import { Spinner } from "@cd2/components"
import { DelayedRender } from "./DelayedRender"
import { Frame } from "./Frame"

export function LoadingFrame({ minHeight, ms }: { minHeight?: number; ms?: number }) {
  return (
    <Frame minHeight={minHeight}>
      <DelayedRender ms={ms}>
        <Spinner color="black" />
      </DelayedRender>
    </Frame>
  )
}
